<template lang="pug">
li(class="tl-accordion__item")
    div(
        class="tl-accordion__trigger"
        :class="{'tl-accordion__trigger--active': visible}"
        @click="open"
    )
        slot(name="trigger")
        i(
            class="tl-accordion__trigger-icon mi-chevron-down"
            :class="{ opened: visible }"
        )
    transition(
        name="tl-accordion"
        @enter="onEnter"
        @after-enter="onLeave"
        @before-leave="onEnter"
        @after-leave="onLeave"
    )
        .div(
            v-if="visible"
            class="tl-accordion__content-wrapper"
        )
            div(class="tl-accordion__content")
                slot(name="content")
</template>

<script lang="ts" setup>
import { ref, computed, inject } from 'vue'
import { ACCORDION_KEY } from './consts'

const accordion = inject(ACCORDION_KEY)

if (!accordion) {
    throw ('Accordion is not injected')
}

const index = ref(-1)
const visible = computed(() => accordion.state[index.value])

accordion.state.push(false)
index.value = accordion.state.length - 1

if (+accordion.props.activeIndex === index.value) {
    accordion.state[index.value] = true
}

const open = () => {
    if (!accordion.props.multi) {
        accordion.state = Array(accordion.state.length).fill(false)
    }
    accordion.state[index.value] = !accordion.state[index.value]
}
const onEnter = (el: Element) => {
    (el as HTMLElement).style.height = el.scrollHeight + 'px'
}

const onLeave = (el: Element) => {
    (el as HTMLElement).style.height = ''
}
</script>

<style lang="sass" scoped>
.tl-accordion__item
    --padding-item: var(--padding-3) 0
    --padding-trigger: 0
    --padding-content: var(--padding-3) 0
    padding: var(--padding-item)
    border-bottom: 1px solid #ebebeb
    position: relative
    &:last-of-type
        border: none

.tl-accordion__trigger
    padding: var(--padding-trigger)
    cursor: pointer
    display: flex
    justify-content: space-between
    align-items: center

.tl-accordion__trigger-icon
    transition: all 0.2s ease-in-out
    font-size: 22px
    color: var(--color-black)
    &.opened
        transform: rotate(180deg)

.tl-accordion__content
    padding: var(--padding-content)

.tl-accordion-enter-active, .tl-accordion-leave-active
    transition: height .3s ease, opacity .3s ease
    overflow: hidden
    height: 0

.tl-accordion-enter, .tl-accordion-leave-to
    height: 0 !important
    opacity: 0
</style>
